<template>
    <div
        class="space-y-3"
        :style="{
            color: player.textColor,
        }"
    >
        <p class="text-lg font-semibold">
            {{ $t("r_player.description") }}
        </p>
        <cUtilsEdit @edit="goToFileField(currentFile.id, 'fileDescription')">
            <div
                v-html="descriptionContent"
                class="text-base"
                :style="{
                    color: player.textColor,
                }"
            ></div>
        </cUtilsEdit>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { richTextModel } from "@easy/ui/forms";
import { usePlayerGoTo } from "@/views/tools/player/utils/usePlayerGoTo";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "MainDescription",
    components: { cUtilsEdit },
    setup() {
        const { goToFileField } = usePlayerGoTo();
        return { goToFileField };
    },
    computed: {
        ...mapState("player/view", ["player"]),
        ...mapGetters("player/view", ["currentFile"]),
        descriptionContent() {
            return this.currentFile.description
                ? richTextModel.parseToHTMLFromMarkdown(this.currentFile.description)
                : "";
        },
    },
};
</script>
